import { functionalityStore } from '@/components/Functionality';
import appStore               from '@/stores/appStore';

export const refreshMapUsages = async () => {
	functionalityStore.refreshUsagesOf('map_limit');

	await appStore.refreshAccountMapUrns();

	functionalityStore.refreshUsagesOf('nb_images');
};
